import Vue from 'vue'
import { formatPrice } from 'lib/util'
import state from 'lib/appState'
import { mapMutations } from 'vuex'

Vue.component('shipping-calculator', {
  props: {
    goal: Number
  },
  data () {
    return {
      state
    }
  },
  methods: {
    ...mapMutations(['toggleMiniCart'])
  },
  computed: {
    isEmpty () {
      return this.state.cart.items.length === 0
    },
    hasFreeShippingOveride () {
      if (window.HU.free_shipping_product) {
        if (state.cart.items.find(item => item.handle === window.HU.free_shipping_product)) return true
      }
      return false
    },
    goalReached () {
      if (this.hasFreeShippingOveride) return true
      return (this.goal <= this.state.cart.total_price)
    },
    goalStarted () {
      return (this.state.cart.total_price > 0)
    },
    spendLabel () {
      const currentSpend = this.state.cart.total_price
      const goal = this.goal
      if (currentSpend < goal) {
        return 'Currently you have spent $' + currentSpend * 0.01 + '. Spend another $' + (goal - currentSpend) * 0.01 + ' to get free shipping.'
      } else {
        return 'Currently you have spent $' + currentSpend * 0.01 + ', you will get free shipping'
      }
    },
    progress () {
      if (this.hasFreeShippingOveride) return '100%'
      return `${(this.state.cart.total_price * 100 / this.goal)}%`
    },
    price () {
      const price = formatPrice(this.goal - this.state.cart.total_price)
      let resultPrice = '$' + price

      if (price % 1 !== 0) {
        resultPrice = this.$options.filters.currency(price, 2)
      }
      return (price > 0) ? resultPrice : '$' + formatPrice(this.goal)
    }
  },
  beforeUpdate () {
    if (this.goalReached && this.$refs.indicator) this.$refs.indicator.style.width = '100%'
  }
})
